export const FROALA3_LECENSE_KEY = 'lSA3D-17C1E1F2H2F2I1rXYb1VPUGRHYZNRJd1JVOOb1HAc1zG2B1A2B2D6B1B2C4F1D3==';

export const toolbarButtons = {
  moreText: {
    buttons: ['bold', 'italic', 'underline', 'fontSize', 'quote', 'clearFormatting', 'textColor', 'backgroundColor'],
    buttonsVisible: 4,
  },
  moreParagraph: {
    buttons: ['mathButtonV3', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'outdent', 'indent'],
    buttonsVisible: 4,
  },
  moreRich: {
    buttons: ['insertLink', 'insertTable', 'html'],
  },
  moreMisc: {
    buttons: ['undo', 'redo'],
    align: 'right',
    buttonsVisible: 2,
  },
};

export const toolbarButtonsMD = {
  moreText: {
    buttons: ['bold', 'italic', 'underline', 'fontSize', 'quote', 'clearFormatting', 'textColor', 'backgroundColor'],
    buttonsVisible: 3,
  },
  moreParagraph: {
    buttons: ['mathButtonV3', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'outdent', 'indent'],
    buttonsVisible: 4,
  },
  moreRich: {
    buttons: ['insertLink', 'insertTable', 'html'],
  },
  moreMisc: {
    buttons: ['undo', 'redo'],
    align: 'right',
    buttonsVisible: 2,
  },
};

export const toolbarButtonsLite = {
  moreText: {
    buttons: ['bold', 'italic', 'underline', 'clearFormatting', 'textColor'],
    buttonsVisible: 6,
  },
  moreParagraph: {
    buttons: ['mathButtonV3'],
    buttonsVisible: 1,
  },
  moreRich: {
    buttons: [],
    buttonsVisible: 0,
  },
  moreMisc: {
    buttons: ['undo', 'redo'],
    align: 'right',
    buttonsVisible: 2,
  },
};

export const extraConfigDefault = {
  toolbarButtons: toolbarButtonsLite,
  toolbarButtonsMD: toolbarButtonsLite,
  toolbarButtonsSM: toolbarButtonsLite,
  toolbarButtonsXS: toolbarButtonsLite,
  quickInsertEnabled: false,
};

export const scriptsEnabled = [
  'align',
  'alignWithDefault',
  'codeBeautifier',
  'codeView',
  'colors',
  'quote',
  'draggable',
  'entities',
  'fontSize',
  'fullscreen',
  'inlineStyle',
  'lineBreaker',
  'link',
  'lists',
  'paragraphFormat',
  'save',
  'url',
  'wordPaste',
  'table',
  'mathPluginv3',
];
